<template>
  <div id="reporter-results" class="p-2" style="background-color: #eeeeee">
    <div v-if="
      searchResults.data &&
      searchResults.data.length > 0 &&
      numberOfRecords === 0
    ">
      <h2></h2>
    </div>

    <div v-else-if="searchResults.data && numberOfRecords > 0">
      <button @click="csvExport()">Download</button>
      <div class="m-4">{{ searchResults.data.length }} results</div>
      <div class="m-4">
        <b-row>
          <b-col>
            <b-button class="ml-3 mr-3" variant="link" v-for="(s, i) in Object.keys(tableSettingsObj)" v-bind:key="s"
              :id="`link-${i}`" v-model="tableSettings[s]" :name="`link-${i}`" inline
              @click="tableSettings[s] = !tableSettings[s]" v-show="tableSettingsObj[s].show">
              {{
                tableSettings[s]
                  ? tableSettingsObj[s].say
                  : tableSettingsObj[s].say.replace("IDs", "names")
              }}
            </b-button>
          </b-col>
        </b-row>
        <!-- <b-row class="ml-3">
          <b-form-checkbox
            v-for="(s, i) in Object.keys(tableSettingsObj)"
            v-bind:key="s"
            :id="`checkbox-${i}`"
            v-model="tableSettings[s]"
            :name="`checkbox-${i}`"
            inline
            :value="true"
            :unchecked-value="false"
            v-show="tableSettingsObj[s].show"
          >
            {{ tableSettingsObj[s].say }}
          </b-form-checkbox>
        </b-row> -->

        <b-table-lite :busy="tableBusy" sticky-header="700px" outlined small :refreshed="updateParent('tableBusy')"
          striped :per-page="perPage" :current-page="currentPage" hover responsive bordered details-td-class="apes"
          tbody-td-class="apes" tbody-tr-class="hat" :items="compiledSearchResults" :fields="fieldDefinitions"
          caption-top :dark="tableSettings.darkMode">
          <template #table-caption>{{ searchResults.phrase }}.</template>
        </b-table-lite>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reporter",
  props: {
    searchResults: Object,
    clientBundle: Object,
  },
  data: function () {
    return {
      perPage: 100,
      currentPage: 1,
      tableBusy: false,
      tableSettings: {
        fixNames: true,
        fixFieldIds: true,
        fixFolderNames: true,
        fixDatabaseNames: true,
        darkMode: false,
      },
    };
  },
  mounted: function () {
    this.getLocal();
  },
  watch: {
    tableSettings: {
      deep: true,
      handler: function () {
        this.saveLocal();
      },
    },
  },
  computed: {
    tableSettingsObj: function () {
      const t = this;
      return {
        fixNames: {
          say: "Show user IDs",
          do: false,
          show: t.compiledStaffIDFields.length > 0,
        },
        fixFieldIds: { say: "Show field IDs", do: false, show: true },
        fixFolderNames: {
          say: "Show folder IDs",
          do: false,
          show: t.searchResults.headers
            .map((x) => x.ID)
            .includes("parentFolder"),
        },
        fixDatabaseNames: {
          say: "Show server IDs",
          do: false,
          show: t.searchResults.headers
            .map((x) => x.ID)
            .includes("parentDatabase"),
        },
      };
    },
    compiledStaffIDFields: function () {
      const t = this;
      try {
        return [
          ...t.searchResults.headers
            .map((x) => x.ID)
            .filter((y) =>
              [
                ...t.clientBundle.gFields.complete
                  .filter((b) => b.Validation === "StaffIDList")
                  .map((x) => x.ID),
                "ModBy",
                "RowModBy",
                "SystemApprovedBy",
              ].includes(y)
            ),
        ];
      } catch {
        return [];
      }
    },
    compiledSearchResults: function () {
      const t = this;
      const dataArray = JSON.parse(JSON.stringify(t.searchResults.data));
      dataArray.forEach((e) => {
        //fix names
        // "ModBy" is hardcoded because its not listed as StaffID but contains DBELT style listings
        if (t.tableSettings.fixNames && t.compiledStaffIDFields.length > 0) {
          t.compiledStaffIDFields.forEach((staffField) => {
            e[staffField] = Array.isArray(e[staffField])
              ? e[staffField].map((uu) => t.lookupFullName(uu))
              : t.lookupFullName(e[staffField]);
          });
        }
        //fix folder IDs
        if (t.tableSettings.fixFolderNames && e.parentFolder) {
          e.parentFolder = t.lookupFolderName(e.parentFolder);
        }
        //fix database IDs
        if (t.tableSettings.fixDatabaseNames && e.parentDatabase) {
          e.parentDatabase = t.lookupServerName(e.parentDatabase);
        }

        //join arrayed field values
        Object.keys(e)
          .filter((y) => Array.isArray(e[y]))
          .forEach((x) => {
            e[x] = e[x].join(", ");
          });
      });

      return dataArray;
    },
    numberOfRecords: function () {
      return this.searchResults.data ? this.searchResults.data.length : 0;
    },
    fieldDefinitions: function () {
      const t = this;
      return t.searchResults.headers.map((x) => {
        return {
          key: x.ID,
          label: t.tableSettings.fixFieldIds
            ? x.DefaultCaption
            : `${x.DefaultCaption} [${x.ID}]`,
        };
      });
    },
    csvData() {
      const t = this;
      const headers = t.searchResults.headers.map((x) => x.ID);
      // const headers = t.fieldDefinitions.map((x) => x.ID);
      let ret = [];

      function sanitize(value) {
        if (value === undefined || value === null) return "";
        if (typeof value !== "string") value = String(value);
        value = value
          // Replace tabs with 4-space
          .replace(/\t/g, "    ")
          // Replace non-breaking spaces with normal spaces
          .replace(/\u00A0/g, " ")
          // Replace newlines with a ⏎
          .replace(/\r?\n|\r/g, "⏎")
          // Escape quotes for Excel
          .replace(/"/g, '""');
        // wrap in double quotes for TSV safety
        return `"${value}"`;
      }
      // t.searchResults.data.forEach((line) => {
      t.compiledSearchResults.forEach((line) => {
        let arr = [];
        headers.forEach((head) => {
          arr.push(sanitize(line[head]));
        });
        ret.push(arr.join("\t"));
      });
      return ret;
    },
  },
  methods: {
    lookupFullName: function (_u) {
      const t = this;
      return (
        t.clientBundle.gTables._Staff
          .filter((y) => y.UserID === _u)
          .map((x) => `${x.GivenName} ${x.Surname}`)
          .toString() || _u
      );
    },
    lookupServerName: function (_s) {
      const t = this;
      return t.clientBundle.gTables._Servers.filter((y) => y.ServerID === _s)[0]
        .Description;
    },
    lookupFolderName: function (_p) {
      const t = this;
      return (
        t.clientBundle.gTables._Groups
          .filter((y) => y.ID === _p)
          .map((x) => `${x.Description} (${t.lookupServerName(x.Server)})`)
          .toString() || _p
      );
    },
    updateParent: function (updateType) {
      const t = this;
      if (updateType === "tableBusy") {
        t.$emit("tableBusyStateChange", false);
      }
    },
    csvExport() {
      const t = this;
      let tsvRows = [
        t.fieldDefinitions.map((x) => x.label).join("\t"),
        ...t.csvData, // already contains sanitized, tab-separated rows
      ];
      // Combine all rows with line breaks
      let tsvContent = tsvRows.join("\r\n").replace(/(^\[)|(\]$)/gm, ""); // as before

      // --- THE FIX: Use a Blob for download, not a data: URI! ---
      const blob = new Blob([tsvContent], {
        type: "text/tab-separated-values;charset=utf-8",
      });

      // Create a temporary anchor to download the blob
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export.tsv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    // csvExport() {
    //   const t = this;
    //   let csvContent = "data:text/tab-separated-values;charset=utf-8,";
    //   csvContent += [
    //     t.fieldDefinitions.map((x) => x.label).join("\t"),
    //     // t.searchResults.headers.map((x) => x.DefaultCaption).join("\t"),
    //     ...t.csvData,
    //   ]
    //     .join("\r\n")
    //     .replace(/(^\[)|(\]$)/gm, "");

    //   const data = encodeURI(csvContent);
    //   const link = document.createElement("a");
    //   link.setAttribute("href", data);
    //   link.setAttribute("download", "export.tsv");
    //   link.click();
    // },
    getLocal: function () {
      var t = this;
      var settings = JSON.parse(window.localStorage.getItem("tableSettings"));
      if (settings) {
        for (let k in settings) {
          t.tableSettings[k] = settings[k];
        }
      }
    },
    saveLocal: function () {
      var t = this;
      window.localStorage.setItem(
        "tableSettings",
        JSON.stringify(t.tableSettings)
      );
    },
  },
};
</script>
<style>
td {
  max-width: 650px;
  word-wrap: break-word;
  text-align: left;
}
</style>
